module.exports = __webpack_public_path__ + "img/tips2.8f3bb25e.png";